(function () {
  'use strict';

  /* @ngdoc object
   * @name trainingAuditReport
   * @description
   *
   */
  angular
    .module('trainingAuditReport', [
      'ui.router'
    ]);
}());
